import script from "./support_page.vue?vue&type=script&setup=true&lang=js"
export * from "./support_page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__